module.exports = __webpack_public_path__ + "img/03.b4935172.jpg";